// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2_JBC","label":"Section_label__2uUoB","contentWrap":"Section_contentWrap__20XOO","footer":"Section_footer__3z2vo","footerInner":"Section_footerInner__2xesS"};